import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import validate from 'utils/validate';
import { useForm, FormProvider } from 'react-hook-form';
import { useSelector } from 'react-redux';
import {
  PrimaryButton,
  FormattedError,
  Heading,
  Link,
  Text,
  Box,
  Panel,
  PanelContent,
} from 'components';
import { I18nContext } from 'components/I18n';
import {
  TextField,
  FormField,
} from 'components/Forms';

function CreateAccountComponent(props) {
  const {
    error,
    onSubmit,
    brandNamePossessive,
    termsAndConditionsUrl,
  } = props;
  const i18n = useContext(I18nContext);
  const methods = useForm({ mode: 'onChange' });
  const { handleSubmit } = methods;
  
  const { loginEnabled, location } = useSelector(state => ({
    loginEnabled: state.settings.loginEnabled,
    location: state.router.location,
  }));

  return (
    <Panel textAlign="center">
      <Heading id="createAccount" mb="medium" />

      <Heading
        id="createAccount.createAccount.subHeader"
        isHtml
        fontSize="medium"
        mb="medium"
        as="h2"
      />
      <FormProvider {...methods}>
        <PanelContent centered as="form" onSubmit={handleSubmit(onSubmit)} method="POST" noValidate>
          <FormField
            as={TextField}
            name="email"
            placeholder={i18n.formatText('email')}
            type="text"
            validations={{
              email: validate.email(),
            }}
          />
          <FormattedError error={error} />

          <Box my="medium">
            <PrimaryButton variant="brand" type="submit">
              <Text id="createAccount" />
            </PrimaryButton>
          </Box>

          {termsAndConditionsUrl && (
            <Box margin="fine">
              <Text
                id="createAccount.termsMessage"
                values={{
                  brandNamePossessive,
                  termsAndConditionsLink: (
                    <Link
                      key="termsAndConditionsUrl"
                      href={termsAndConditionsUrl}
                      target="_blank"
                      id="termsAndConditions"
                    />
                  ),
                }}
                fontSize="fine"
              />
            </Box>
          )}
          
          {loginEnabled && (
            <Box mt="medium">
              <Text
                bold
                color="secondary"
                fontSize="medium"
                id="haveAccountLogIn"
                values={{
                  logInLink: (
                    <Link
                      key="logInLink"
                      to={{
                        name: 'log-in',
                        params: {
                          platform: location.params?.platform,
                        },
                      }}
                      id="logIn"
                    />
                  ),
                }}
              />
            </Box>
          )}
        </PanelContent>
      </FormProvider>
    </Panel>
  );
}

CreateAccountComponent.propTypes = {
  brandNamePossessive: PropTypes.string.isRequired,
  termsAndConditionsUrl: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default CreateAccountComponent;
